export const isInSeries = (index, length) => {
  if (index >= length - 3) {
    return false
  }

  let current = 6 // First index in series
  while (current <= index) {
    if (current === index) {
      return true
    }
    current += (current - 6) % 18 === 0 ? 7 : 11
  }
  return false
}
